
import { Component, Vue } from 'vue-property-decorator';
import OsAppusersOverview from '@/components/shared/appusers/OsAppusersOverview.vue';
import OsInternalUsersOverview from '@/components/shared/internalusers/OsInternalUsersOverview.vue';
import { IAppuser } from '@/models/application';
import OsQuestionnairesOverview from '@/components/shared/questionnairs/OsQuestionnairesOverview.vue';
@Component({
  components: {
    OsQuestionnairesOverview,
    OsInternalUsersOverview,
    OsAppusersOverview
  }
})
export default class SettingsQuestionnairesIndex extends Vue {
  openExisting(selected: IAppuser) {
    this.$router.push(`/settings/questionnaires/${selected.id}`);
  }
}
